import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';
import { VAULT_MAX_FILE_SIZE, VAULT_UPLOAD_MIME_TYPES } from '../constants/vault-upload.const';

export const MAX_FILE_SIZE = VAULT_MAX_FILE_SIZE;

export const ACCEPTED_FILE_MIME_TYPES = VAULT_UPLOAD_MIME_TYPES;
export const fileSchemaMessage = getTranslation('FILE_SIZE_TOO_LARGE');

export const formSchema = z.object({
  files: z
    .object({
      docLink: z.string(),
      loadProgress: z.number().max(100),
      abort: z.function(),
      id: z.string(),
      doc: z
        .custom<File>()
        .or(
          z.object({
            size: z.number(),
            type: z.string(),
            name: z.string(),
          }),
        )
        .refine(
          ({ type }) => ACCEPTED_FILE_MIME_TYPES.includes(type),
          getTranslation('FILE_FORMAT_NOT_SUPPORTED'),
        )
        .refine(({ size }) => size <= MAX_FILE_SIZE, fileSchemaMessage),
    })
    .array(),
});

export type FormSchema = z.infer<typeof formSchema>;
